import React, { useEffect } from 'react';
import Nav from '../nav';

import { Container } from './styles';

function Hero() {

  return (
    <Container>
      <Nav />
      {/* <Mockup /> */}
    </Container>
  );
}

export default Hero;